import React, { useState, useEffect } from "react";
import AkkhorLayout from "../../layout/akkhor";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { URL_LIST_ALL } from "../../configs/api";
import Axios from "axios";
import { confirmAlert } from "react-confirm-alert";
import { Spinner } from "react-bootstrap";

export default function UserCheckin() {
    const { user } = useSelector((state) => state.auth);
    const { id } = useParams();
    const [detail, setDetail] = useState(null)
    const [loading,setLoading] = useState(false)

    useEffect(
        function () {
            if (id && id != '') {
                let mounted = true;
                Axios.get(URL_LIST_ALL + "checkin?alias=" + id, user.config)
                    .then(async (res) => {
                        if (res.data.status === "success") {
                            if (mounted) {
                                setDetail(res.data.data[0])
                            }
                        } else alert(res.data.message);
                    })
                    .catch((err) => console.log(err));
                return () => (mounted = false);
            }
        }, [user, id]
    );

    const accessCheckin = () => {
        setLoading(true)
        const values = { checkin_id: detail.id, user_id: user.data.id }
        Axios.post(URL_LIST_ALL + 'checkin_user', values, user.config).then(res => {
            setLoading(false)
            if (res.data.status === "success") {
                // invited === false: user check-in thành công nhưng không có mã trong danh sách
                // được mời (checkin.user_join) -> báo rõ để họ liên hệ ban tổ chức.
                const notInvited = res.data.invited === false;
                confirmAlert({
                    title: "Thông báo",
                    message: notInvited
                        ? "Thông tin đăng ký của Anh/Chị đang được xác nhận. Vui lòng liên hệ BTC để được hỗ trợ."
                        : "Bạn đã checkin thành công",
                    buttons: [{
                        label: "OK",
                        onClick: () => {
                            window.location.href = '/bang-tin'
                        },
                    }, { label: "Không" },
                    ],
                });
            } else alert(res.data.message);
        }).catch((err) => {console.log(err);setLoading(false)});
    }

    return <AkkhorLayout idrole="dashboard">
        <div className="row">
            <div className="col-12 col-sm-3"></div>
            <div className="col-12 col-sm-6 mt-5">
                {detail &&
                    <div className="wrapper p-3 bg-white border shadow-sm rounded">
                        <h4 className="w-100 text-center">{detail.title}</h4>
                        <p className="w-100 text-center mt-2"><strong>Bạn có muốn checkin ?</strong></p>
                        <div className="w-100 d-flex justify-content-center mt-2">
                            <button className="btn btn-success" disable={loading} type="button" style={{ width: "150px" }} onClick={() => accessCheckin()}>{loading ?<Spinner/> : 'Đồng ý'}</button>
                            <button className="btn btn-danger ml-2" type="button" style={{ width: "150px" }}>Hủy</button>
                        </div>
                    </div>
                }

            </div>
        </div>
    </AkkhorLayout>
}